import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCertifiedRibbon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "certified-ribbon" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "4.807 13.042 0.75 18 4.5 18.75 6 23.25 9.944 16.992"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "19.193 13.042 23.25 18 19.5 18.75 18 23.25 14.056 16.992"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,9a8.246,8.246,0,1,1-4.5-7.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18,5.25l-5.47,5.47a.749.749,0,0,1-1.06,0L9.75,9"
		})
	]
});
export default SvgCertifiedRibbon;
